import React, { useEffect }  from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams,useNavigate } from 'react-router-dom';
import JobCertification from './JobCertification';
import { formValueSelector, getFormValues } from 'redux-form';
import { jobVerificationForm } from 'constants/FormConstants';
import { isImportJobType } from 'util/JobTypeHelper';
import {
  getContactsByAreaId,
  getDefaultContactsByNoticeKey,
} from 'selectors/formSelectors';
import ClientDetailsSectionContainer from '../../jobdetails/ClientDetailsSectionContainer';
import { getClientDetails } from '../../../actions/clientDetailsActions';
import { reduxForm } from 'redux-form';

const JobCertificationContainer = () => {
  
  const { id: jobId } = useParams();
  const dispatch = useDispatch();
  const currentJob =  useSelector((state) => state.currentJob ||{});//state1.currentJob;
  const areaId = currentJob ? currentJob.areaId : null;
  const jobType = currentJob.type;
  //const clientDetails = useSelector((state)=>state.clientDetails)
  const navigate = useNavigate();
  /*useEffect(() => {
    if (!clientDetails) {
      dispatch(getClientDetails(currentJob.clientCode)); // Dispatch action to load client details
    }
  }, [dispatch, clientDetails, jobId]);

  if (!clientDetails) {
    return <div>Loading client details...</div>;
  }
  console.log('JobCertConCD',state1)*/
 
  //const clientStatus = clientDetails.status?clientDetails.status :null;
  const contacts =useSelector((state)=>state.referenceData.contacts);// state1.referenceData
  //const formValues = formValueSelector(jobVerificationForm)(state);
  const formValues = useSelector((state) => state.form[jobVerificationForm]?state.form[jobVerificationForm].values:null);
  const clientDetailsStatus = useSelector((state)=>state.form[ClientDetailsSectionContainer]?state.form[ClientDetailsSectionContainer].values:null);
  //const clientDetailsStatus = null;//formValueSelector(ClientDetailsSectionContainer)(state1, 'clientDetails.ClientStatus');
  const initialValues = {
    ...currentJob,
    newTreatmentCertificate: {
      contactIds: getDefaultContactsByJobType(contacts, areaId, jobType),//(referenceData.contacts, areaId, jobType),
      sendNotice: true,
    },
  };

  return (
    <JobCertification
      status={clientDetailsStatus}
      clientDetails={clientDetailsStatus}
      currentJob={currentJob}
     // certifyJob={formValues.jobTransitionActions.certifyJob}
      contacts={contacts}
      formValues={formValues}
      initialValues={initialValues}
      navigate={navigate}
    />
  );
};

function getDefaultContactsByJobType(contacts, areaId, jobType) {
  if (!jobType) return null;
  return isImportJobType(jobType)
    ? getDefaultImportContacts(contacts, areaId)
    : getDefaultExportContacts(contacts, areaId);

}

function getDefaultImportContacts(contacts, areaId) {
  return getDefaultContactsByNoticeKey(
    contacts,
    areaId,
    'defaultForTreatmentCertificateImport'
  );
}

function getDefaultExportContacts(contacts, areaId) {
 return getDefaultContactsByNoticeKey(
    contacts,
    areaId,
    'defaultForTreatmentCertificateExport'
  );
}
//export default reduxForm({ form: jobVerificationForm })(JobCertificationContainer);
export default JobCertificationContainer;
